import React, { FC } from 'react';

import { Box, Avatar, Flex, Text, HStack } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

import { selectApp } from 'containers/App/selectors';

import { Form, renderTime } from '../../../components';
import { form_styles } from '../styles';
import { ProfileProps } from '../types';

export const Profile: FC<ProfileProps> = props => {
  const {
    firstName,
    lastName,
    username,
    createdTimestamp,
    email,
    lastLogin,
    orgName,
    phone,
    source,
    guid,
  } = props;

  const { userAuth } = useSelector(selectApp);

  const phoneNumber = phone?.split('-');
  // Profile editing is hidden (read-only fields, no Edit/Save/Cancel) because
  // no API persists these fields; Save used to silently discard the edits.

  const renderTimeAndLogin = (label, value) => (
    <HStack w="full">
      <Text color="gray.300">{label}:</Text>
      <Text>{value ?? '-'}</Text>
    </HStack>
  );

  return (
    <Box>
      <Flex pb={3} align="center">
        <Avatar size="md" />
        <Text pl={4} fontSize={16}>
          {firstName && lastName
            ? `${firstName} ${lastName}`
            : firstName
            ? firstName
            : lastName
            ? lastName
            : 'First Name, Last Name'}
        </Text>
      </Flex>
      <Form
        schema={{
          userId: {
            type: 'text',
            label: 'User ID',
            isDisabled: true,
          },
          email: {
            type: 'text',
            label: 'Email ID',
            isDisabled: true,
          },
          phone: {
            type: 'object',
            label: 'Phone',
            properties: {
              countryCode: {
                type: 'react-select',
                options: [
                  { label: '+91', value: '+91' },
                  { label: '+1', value: '+1' },
                ],
                defaultValue: phoneNumber
                  ? { value: phoneNumber[0], label: phoneNumber[0] }
                  : {},
                isDisabled: true,
              },
              phone: {
                type: 'text',
                placeholder: 'Phone Number',
                //htmlInputType: 'tel',
                isDisabled: true,
              },
            },
          },
          org_name: {
            type: 'text',
            label: 'Organization',
            isDisabled: true,
          },
          source: {
            type: 'text',
            label: 'Source',
            isDisabled: true,
          },
          createdTimestamp: {
            type: 'custom',
            component: () => (
              <HStack>
                {renderTimeAndLogin(
                  'Created On',
                  renderTime({ value: createdTimestamp }),
                )}
                {renderTimeAndLogin(
                  'Last Login',
                  !!userAuth.data.sessions?.length
                    ? renderTime({
                        value:
                          userAuth.data.sessions[
                            userAuth.data.sessions?.length - 1
                          ].start_at,
                      })
                    : '-',
                )}
              </HStack>
            ),
          },
        }}
        formOptions={{
          defaultValues: {
            userId: username,
            guid,
            source: source,
            lastLogin: lastLogin,
            createdTimestamp,
            org_name: orgName,
            email,
            phone: {
              countryCode: phoneNumber && phoneNumber[0],
              phone: phoneNumber && phoneNumber[1],
            },
          },
        }}
        styles={form_styles}
        // Reset (Cancel) is hidden by the Form defaults.
        buttonOptions={{ submit: { isVisible: false } }}
        handleSubmit={() => {}}
      />
    </Box>
  );
};
